"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startBooking = exports.setBookingConfirmation = exports.recognizePassport = exports.bookingActions = void 0;
var _reduxActions = require("redux-actions");
var bookingActions = exports.bookingActions = (0, _reduxActions.createActions)({
  recognizePassport: function recognizePassport(uiKey, passport, onSuccess) {
    return {
      passport: passport,
      onSuccess: onSuccess,
      uiKey: uiKey
    };
  },
  setBookingConfirmation: function setBookingConfirmation(bookingConfirmation) {
    return bookingConfirmation;
  },
  startBooking: function startBooking(bookingEntity, queryID) {
    return {
      bookingEntity: bookingEntity,
      queryID: queryID
    };
  }
}, {
  prefix: 'BOOKING_FORM_BY_OPERATOR'
});
var recognizePassport = exports.recognizePassport = bookingActions.recognizePassport,
  setBookingConfirmation = exports.setBookingConfirmation = bookingActions.setBookingConfirmation,
  startBooking = exports.startBooking = bookingActions.startBooking;